<mat-toolbar>
  <button mat-icon-button (click)="back.emit()" class="back-button">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <truncated-text [text]="text" fxFlex></truncated-text>

  <ng-content></ng-content>
</mat-toolbar>
